import Axios from 'axios'
import {facilityDiscountUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_discounts (context) {
    Axios.get(facilityDiscountUrls.getAllFacilityDiscounts).then(function (response) {
      context.commit('GET_ALL_FACILITY_DISCOUNTS', response.data)
    })
  },
  get_facility_discounts (context, publicId) {
    Axios.get(facilityDiscountUrls.getFacilityDiscounts + publicId).then(function (response) {
      context.commit('GET_FACILITY_DISCOUNTS', response.data)
    }).catch(function () {
      context.commit('GET_FACILITY_DISCOUNTS', [])
    })
  },
  get_deleted_facility_discounts (context) {
    Axios.get(facilityDiscountUrls.getDeletedFacilityDiscount).then(function (response) {
      context.commit('GET_DELETED_FACILITY_DISCOUNTS', response.data)
    })
  },
  get_facility_discount (context, publicId) {
    Axios.get(facilityDiscountUrls.getFacilityDiscount + publicId).then(function (response) {
      context.commit('GET_FACILITY_DISCOUNT', response.data)
    })
  },
  post_facility_discount (context, data) {
    Axios.post(facilityDiscountUrls.postFacilityDiscount, data).then(function () {
      context.dispatch('get_facility_discounts', data.facility_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_facility_discount (context, data) {
    Axios.post(facilityDiscountUrls.editFacilityDiscount, data).then(function () {
      context.dispatch('get_all_facility_discounts')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_facility_discount (context, data) {
    Axios.post(facilityDiscountUrls.deleteFacilityDiscount + data.public_id, data).then(function (response) {
      context.dispatch('get_facility_discounts', data.facility_id)
    })
  },
  restoreFacilityDiscount (context, publicId) {
    Axios.get(facilityDiscountUrls.restoreFacilityDiscount + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_DISCOUNTS', response.data)
      router.push({
        name: 'Module.FacilityDiscounts'
      })
    })
  }
}
